export const GET_SPENDGO_CONFIG_REQUESTED = 'brand/GET_SPENDGO_CONFIG_REQUESTED';
export const GET_SPENDGO_CONFIG_SUCCESS = 'brand/GET_SPENDGO_CONFIG_SUCCESS';
export const GET_SPENDGO_CONFIG_FAILURE = 'brand/GET_SPENDGO_CONFIG_FAILURE';

export const UPDATE_SPENDGO_CONFIG_REQUESTED = 'brand/UPDATE_SPENDGO_CONFIG_REQUESTED';
export const UPDATE_SPENDGO_CONFIG_SUCCESS = 'brand/UPDATE_SPENDGO_CONFIG_SUCCESS';
export const UPDATE_SPENDGO_CONFIG_FAILURE = 'brand/UPDATE_SPENDGO_CONFIG_FAILURE';

const initialState = {
  loading: false,
  loaded: false,
  error: false,
  spendgoList: [],
};

export default(state = initialState, action) => {
  switch (action.type) {
    case GET_SPENDGO_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        spendgoList: [],
      };
    }
    case GET_SPENDGO_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        spendgoList: action.result,
      };
    }
    case GET_SPENDGO_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }
    case UPDATE_SPENDGO_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case UPDATE_SPENDGO_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
      };
    }
    case UPDATE_SPENDGO_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
};

export const getSvsConfig = (brandId) => {
  return {
    types: [GET_SPENDGO_CONFIG_REQUESTED, GET_SPENDGO_CONFIG_SUCCESS, GET_SPENDGO_CONFIG_FAILURE],
    promise: client => client.get(`getSpendgoConfig/${brandId}`)
  };
};

export const updateSvsConfig = (brandId, data) => {
  return {
    types: [UPDATE_SPENDGO_CONFIG_REQUESTED, UPDATE_SPENDGO_CONFIG_SUCCESS, UPDATE_SPENDGO_CONFIG_FAILURE],
    promise: client => client.post(`updateSpendgoConfig/${brandId}`, { data })
  };
};
